( function ( $ ) {

    const contactFormModalHash = '#contact-form';
    const contactFormModalHashAliases = {
        '#contact-us': contactFormModalHash,
    };

    function getHashFromHref( href ) {
        if ( !href ) {
            return '';
        }
        const hashIndex = href.indexOf( '#' );
        return hashIndex === -1 ? '' : href.slice( hashIndex );
    }

    function resolveHashTarget( hash ) {
        let $target = $( hash );

        if ( !$target.length && contactFormModalHashAliases[hash] ) {
            hash = contactFormModalHashAliases[hash];
            $target = $( hash );
        }

        return { hash, $target };
    }

    // Smooth-scroll / toggle modal on in-page hash links (including /path/#anchor).
    $( document ).on( 'click', 'a[href*="#"]', function ( e ) {
        const hash = getHashFromHref( this.getAttribute( 'href' ) );

        if ( !hash || hash === '#' ) {
            return;
        }

        const { $target } = resolveHashTarget( hash );

        if ( !$target.length ) {
            return;
        }

        e.preventDefault();

        if ( $target.hasClass( 'modal' ) ) {
            bootstrap.Modal.getOrCreateInstance( $target[0] ).toggle();
            return;
        }

        $( 'html, body' ).animate(
            { scrollTop: $target.offset().top },
            500,
            function() {
                $target.focus();
                if ( $target.is( ':focus' ) ) {
                    return false;
                }

                $target.attr( 'tabindex', '-1' );
                $target.focus();
            }
        );
    } );

    // Load embedded videos only when a video modal opens; stop on close.
    $( document ).on( 'shown.bs.modal', '.modal-video', function () {
        $( this ).find( 'iframe[data-src]' ).each( function () {
            this.src = this.dataset.src;
        } );
    } );

    // Highlights in hidden modals are not in view at page load, so trigger on open.
    $( document ).on( 'shown.bs.modal', '.modal-contact-form', function () {
        $( this ).find( '.highlight:not(.s-animation-trigger)' ).addClass( 's-animation-trigger' );
    } );

    $( document ).on( 'hidden.bs.modal', '.modal-video', function () {
        $( this ).find( 'iframe' ).each( function () {
            this.src = '';
        } );
    } );

}( jQuery ) );
